module.exports = __webpack_public_path__ + "img/img2.2a59268.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img2.jpg
// module id = 285
// module chunks = 0